import { inject, Injectable, signal } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { AiExplanationSnack } from '../../../shared/components/ai-explanation-snack/ai-explanation-snack';
import { GameMode } from '../../../shared/model/i-game-mode';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private _snackBar = inject(MatSnackBar);

  private messageError = signal('');
  private aiExplanationSnackRef: MatSnackBarRef<AiExplanationSnack> | null = null;
  private hasPendingAiExplanation = false;
  private isAiExplanationPaused = false;
  private aiExplanationDuration = 5000;
  private aiExplanationGameMode: GameMode = 'coop';

  public setMessage(txt: string){
    this.messageError.set(txt);
  }

  closed(){
    this._snackBar.dismiss();
  }

  display(time: number = 30000) {
    this._snackBar.open(this.messageError(), 'OK', {
      panelClass: '',
      duration: time
    });
  }

  showAiExplanation(gameMode: GameMode, time: number = 5000): void {
    this.hasPendingAiExplanation = true;
    this.aiExplanationDuration = time;
    this.aiExplanationGameMode = gameMode;
    this.displayAiExplanationIfReady();
  }

  pauseAiExplanation(): void {
    this.isAiExplanationPaused = true;
    const snackRef = this.aiExplanationSnackRef;
    this.aiExplanationSnackRef = null;
    snackRef?.dismiss();
  }

  resumeAiExplanation(): void {
    this.isAiExplanationPaused = false;
    this.displayAiExplanationIfReady();
  }

  private displayAiExplanationIfReady(): void {
    if(!this.hasPendingAiExplanation || this.isAiExplanationPaused || this.aiExplanationSnackRef){
      return;
    }

    const config: MatSnackBarConfig = {
      duration: this.aiExplanationDuration,
      horizontalPosition: 'center',
      panelClass: [
        'ai-explanation-snackbar',
        `ai-explanation-snackbar--${this.aiExplanationGameMode}`
      ],
      verticalPosition: 'top'
    };
    const snackRef = this._snackBar.openFromComponent(AiExplanationSnack, config);
    this.aiExplanationSnackRef = snackRef;
    snackRef.afterDismissed().subscribe(() =>{
      if(this.aiExplanationSnackRef === snackRef){
        this.aiExplanationSnackRef = null;
        this.hasPendingAiExplanation = false;
      }
    });
  }
  
}
